import classNames from "classnames";
import React from "react";

export interface ResponsiveItemsPerRow {
  xl?: number;
  lg?: number;
  md?: number;
  sm?: number;
  default?: number;
}

interface GridProps {
  children: React.ReactNode;
  spacing?: number;
  itemsPerRow?: number | ResponsiveItemsPerRow;
}

export function Grid(props: GridProps) {
  const { children, spacing = 8, itemsPerRow } = props;

  return (
    <div
      className="grid-container"
      style={{
        boxSizing: "border-box",
        marginLeft: -spacing / 2,
        marginRight: -spacing / 2,
      }}
    >
      {React.Children.map(children, (child) => {
        if (!child) {
          return null;
        }
        if (!itemsPerRow) {
          return (
            <div
              style={{
                boxSizing: "border-box",
                paddingLeft: spacing / 2,
                paddingRight: spacing / 2,
              }}
              className={`grid-col-xs-12`}
            >
              {child}
            </div>
          );
        }

        if (typeof itemsPerRow === "number") {
          return (
            <div
              style={{
                boxSizing: "border-box",
                paddingLeft: spacing / 2,
                paddingRight: spacing / 2,
              }}
              className={`grid-col-xs-${12 / itemsPerRow}`}
            >
              {child}
            </div>
          );
        }

        return (
          <div
            className={classNames(
              itemsPerRow.default && `grid-col-xs-${12 / itemsPerRow.default}`,
              itemsPerRow.sm && `grid-col-sm-${12 / itemsPerRow.sm}`,
              itemsPerRow.md && `grid-col-md-${12 / itemsPerRow.md}`,
              itemsPerRow.lg && `grid-col-lg-${12 / itemsPerRow.lg}`,
              itemsPerRow.xl && `grid-col-xl-${12 / itemsPerRow.xl}`
            )}
            style={{
              boxSizing: "border-box",
              paddingLeft: spacing / 2,
              paddingRight: spacing / 2,
            }}
          >
            {child}
          </div>
        );
      })}
    </div>
  );
}
